<div #destination class="destination-cont">
  <div class="searchInputDestination__input" [class.results]="isResultsPage">
    <app-ds-input-text
      [isReadonly]="true"
      [isDisabled]="isDisabled"
      [icon]="icon"
      [label]="defaultCityCode || getCountryCode"
      [placeholder]="getCountryName"
      [value]="
        (isResultsPage ? (defaultCityName || getCountryCode) + ', ' : '') + '' +
        (defaultCountry ?? '')
      "
      [isFailed]="showError"
      [failedMessage]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_ORIGIN' | transloco"
      (clickEvent)="toggleInput()">
    </app-ds-input-text>
  </div>
  <div class="searchInputAllPlaces__autocomplete">
    <app-search-input-autocomplete
      [searchType]="searchType"
      [placeType]="placeType"
      [query]="query"
      [isMobile]="isMobile"
      [title]="'SEARCH_MODULE.LOCATION_SEARCH.' + placeTypeText | transloco"
      [viewAutocomplete]="showInput"
      [inputPlaceListIcon]="icon"
      [inputPlaceListLabel]="'SEARCH_MODULE.LOCATION_SEARCH.' + placeTypeText | transloco"
      [inputPlaceListPlaceholder]="'SEARCH_MODULE.LOCATION_SEARCH.' + placeholderText | transloco"
      [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
      [cityAndAirportsAutocomplete]="resultsPlaces"
      [mergeAirportsAndCities]="false"
      [isCollapsableList]="true"
      (closeAutocomplete)="toggleInput()"
      (setQuery)="setQuery($event)"
      (selectPopularPlace)="emitSelectPlace($event)"
      (selectAirportOrCityEvent)="selectAirportOrCity($event)"
      (popularSelected)="popularSelected.emit($event)">
    </app-search-input-autocomplete>
  </div>
</div>

<ng-template #loader>
  <div class="loader-content">
    <app-ds-loader-ring
      [type]="loaderRingType">
    </app-ds-loader-ring>
  </div>
</ng-template>

<ng-template #airportPlaceTemplate let-place='place'>
  <ng-container *ngTemplateOutlet="airportOption; context: { place: place }"></ng-container> 
  <span class="city-code">{{ place.code }}</span>
</ng-template>

<ng-template #airportOption let-place='place'>
  <div class="place-info">
    <p class="city">{{ place.related_city }}, {{ place.country }}</p>
    <p class="airport"><i aria-hidden="true" class="icon-plane"></i> {{ place.description }}</p>
  </div>
</ng-template>
